import ExcelJS from 'exceljs';
import { transYMD } from './scripts';

export const exportXlsx = async (data) => {
  try {
    const wb = new ExcelJS.Workbook();
    const sheet = wb.addWorksheet('기준점');

    await sheetSet(sheet, data);

    const b = await wb.xlsx.writeBuffer();
    const a = { date: '2025', blob: new Blob([b], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) };

    const url = window.URL.createObjectURL(a.blob);
    const down = document.createElement('a');
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const yyyymmdd = `${year}${month}${day}`;
    down.href = url;
    down.download = `지적도근점(${yyyymmdd}).xlsx`;
    down.click();
    down.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.log(e);
  }
};

const sheetSet = (sheet: ExcelJS.Worksheet, data) => {
  //명칭 및 번호 return
  const nameReturn = (feature) => {
    if (feature.getProperties().properties.BASE_NAME === '지적도근점') {
      return feature.getProperties()?.properties.DOGEUN_POI;
    } else if (feature.getProperties().properties.BASE_NAME === '지적삼각보조점') {
      return feature.getProperties()?.properties.TRAG_ASSTC;
    } else if (feature.getProperties().properties.BASE_NAME === '지적삼각점') {
      return feature.getProperties()?.properties.TRAG_POINT;
    }
  };

  sheet.getColumn(1).width = 20;
  sheet.getColumn(2).width = 20;
  sheet.getColumn(3).width = 20;
  sheet.getColumn(4).width = 20;
  sheet.getColumn(5).width = 80;
  sheet.getColumn(6).width = 20;
  sheet.addRows([
    ['※ 아래 내용은 참고용으로 증명용 지적측량기준점성과 등본을 시군구 종합민원실에서 발급받아 확인하시기 바랍니다.', '', '', '', '', ''],
    ['※ 아래 좌표는 측량용으로 활용할 수 없습니다.', '', '', '', '', ''],
    ['', '', '', '', '', ''],
  ]);
  sheet
    .addRows([
      ['지적측량기준점 종류', '명칭 및 번호', '세계측지계', '', '소재지(기준점)', '설치일자'],
      ['', '', '평면직각좌표 X(m)', '평면직각좌표 Y(m)', '', ''],
    ])
    .forEach((i, index) => {
      i.eachCell((cell, colNum) => {
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
        cell.font = { size: 12, bold: false, color: { argb: '000000' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });
  sheet.mergeCells('A1:E1');
  sheet.mergeCells('A2:E2');
  sheet.mergeCells('A4:A5');
  sheet.mergeCells('B4:B5');
  sheet.mergeCells('C4:D4');
  sheet.mergeCells('E4:E5');
  sheet.mergeCells('F4:F5');
  data.forEach((i, index) => {
    let allRow = sheet.addRows([
      [i.getProperties().properties.BASE_NAME, nameReturn(i), i.getProperties().properties.X_CODE, i.getProperties().properties.Y_CODE, i.getProperties()?.properties.DTLOC || '-', transYMD(i.getProperties()?.properties.BUILD_YMD)],
    ]);
    allRow.forEach((i, index) => {
      i.eachCell((cell, colNum) => {
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
        cell.font = { size: 12, bold: false, color: { argb: '000000' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });
  });
};
